import { TFunc } from '../../../../../../../hooks/useNamespacedTranslation';
import React from 'react';
import FlairIcon from '../../../../../../../atomic/atoms/FlairIcon';
import { ControlledSwitchInput } from '../../../../../../../components/form/SwitchInput';
import { FieldValues } from 'react-hook-form';

type Props = {
  t: TFunc;
  onFieldChange: (step: FieldValues) => void;
  formFieldValues: FieldValues | null;
};

export const ShareWithManagerFormField: React.FC<Props> = ({
  t,
  onFieldChange,
  formFieldValues,
}) => {
  const handleFieldChange = (shareWithManager: string) => {
    onFieldChange({
      ...formFieldValues,
      shareWithManager: shareWithManager,
      preview: {
        ...formFieldValues?.preview,
        shareWithManager: shareWithManager,
      },
    });
  };

  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex flex-row align-items-center gap-1">
        <h5 className="h5-regular mb-0">{t('form.fields.shareWithManager')}</h5>
        <FlairIcon
          icon="alert-circle-outline"
          tooltip={t('form.fields.shareWithManagerTooltip')}
          tooltipPlacement="top"
          size="sm"
        />
      </div>
      <ControlledSwitchInput
        className="mb-0"
        onChange={handleFieldChange}
        disabled={formFieldValues?.stayAnonymous}
        checked={formFieldValues?.shareWithManager}
        name="shareWithManager"></ControlledSwitchInput>
    </div>
  );
};
